'use strict';

import request from 'superagent';
import api from './core';

/**
 * List all projects for a client
 * @param client {number} client ID
 * @param page {number} number of the page
 * @returns {Promise}
 */
export function list(client, page = 1) {
    const url = api.url(`/as_projects/`);
    return api.forwardResult(
        api.prepare(request.get(url).query({client, page})),
        'results',
    );
}



// WEBPACK FOOTER //
// ./src/api/projects.js